module.exports = __webpack_public_path__ + "static/media/1.f3e6dc69.jpeg";